import { Avatar, Box, ButtonBase, Stack, Typography } from '@mui/material';
import { ControlledAutocomplete } from 'Components/ControlledAutoComplete';
import { AdvancedSearchContext } from 'Context/MedicalReferralsContext/AdvancedSearchProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { PurpleX } from 'Images';
import { useContext, useState } from 'react';

export const ReferralProvider = () => {
  const { advancedSearch, dispatchAdvancedSearch } = useContext(
    AdvancedSearchContext
  );

  const [inputValue, setInputValue] = useState('');

  const setProvider = (providerName: string | null) =>
    dispatchAdvancedSearch({
      type: 'REQUEST_PROVIDER',
      payload: { value: providerName },
    });

  return (
    <Box position={'relative'} top={'-2px'}>
      <ControlledAutocomplete
        freeSolo
        label={
          Dictionary[DICTIONARY.MedicalReferrals].search.advancedSearch
            .accordingToProviderName
        }
        options={advancedSearch.supplierNames}
        value={advancedSearch.providerName || ''}
        setValue={setProvider}
        inputValue={inputValue}
        setInputValue={setInputValue}
        paperComponent={
          ((inputValue.length !== 0 &&
            advancedSearch.supplierNames.filter((value) =>
              value.includes(inputValue)
            ).length === 0) ||
            advancedSearch.supplierNames.length === 0) && (
            <Stack>
              <Typography variant={'body3'}>
                {
                  Dictionary[DICTIONARY.MedicalReferrals].search.advancedSearch
                    .noResult
                }
              </Typography>
            </Stack>
          )
        }
        style={{ mt: '5px' }}
        disableClearIcon
        endAdornment={
          <Stack
            direction={'row'}
            marginRight={'5px'}
            width={'auto'}
            gap={'15px'}
          >
            {inputValue.length !== 0 && (
              <ButtonBase
                onClick={() => {
                  setInputValue('');
                  setProvider(null);
                }}
              >
                <Avatar
                  alt={''}
                  src={PurpleX}
                  sx={{ width: '20px', height: '20px' }}
                />
              </ButtonBase>
            )}
          </Stack>
        }
      />
    </Box>
  );
};
